function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import thunkHelper from 'invision-core/src/api/thunk.helper';
import { CurrentCustomerIdSelector } from '../selectors/customer.selectors';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
export var UPDATE_USAGE_DETAILS_TYPE_NETWORK_FILTER = 'UPDATE_USAGE_DETAILS_TYPE_NETWORK_FILTER';
export var updateNetworkEventTypeFilter = function updateNetworkEventTypeFilter(data) {
  return {
    type: UPDATE_USAGE_DETAILS_TYPE_NETWORK_FILTER,
    payload: data
  };
};
export var UPDATE_USAGE_DETAILS_SUB_EVENT_FILTER = 'UPDATE_USAGE_DETAILS_SUB_EVENT_FILTER';
export var updateNetworkSubEventTypeFilter = function updateNetworkSubEventTypeFilter(data) {
  return {
    type: UPDATE_USAGE_DETAILS_SUB_EVENT_FILTER,
    payload: data
  };
};
export var UPDATE_USAGE_DETAILS_TYPE_DATE_FILTER = 'UPDATE_USAGE_DETAILS_TYPE_DATE_FILTER';
export var updateUsageDetailsDateFilter = function updateUsageDetailsDateFilter(data) {
  return {
    type: UPDATE_USAGE_DETAILS_TYPE_DATE_FILTER,
    payload: data
  };
};
export var UPDATE_USAGE_DETAILS_CURRENCY_CODE = 'UPDATE_USAGE_DETAILS_CURRENCY_CODE';
export var updateUsageDetailsCurrencyCode = function updateUsageDetailsCurrencyCode(data) {
  return {
    type: UPDATE_USAGE_DETAILS_CURRENCY_CODE,
    payload: data
  };
};
export var UPDATE_USAGE_DETAILS_TOTAL_AMOUNT = 'UPDATE_USAGE_DETAILS_TOTAL_AMOUNT';
export var updateUsageDetailsTotalAmount = function updateUsageDetailsTotalAmount(data) {
  return {
    type: UPDATE_USAGE_DETAILS_TOTAL_AMOUNT,
    payload: data
  };
};
export var UPDATE_USAGE_DETAILS_SORT = 'UPDATE_USAGE_DETAILS_SORT';
export var updateUsageDetailsSort = function updateUsageDetailsSort(sortData) {
  return {
    type: UPDATE_USAGE_DETAILS_SORT,
    payload: sortData
  };
};
export var UPDATE_USAGE_SELECTED_ENTITLEMENT_DETAILS = 'UPDATE_USAGE_SELECTED_ENTITLEMENT_DETAILS';
export var updateUsageDetailsSelectedEntitlementDetails = function updateUsageDetailsSelectedEntitlementDetails(entitlementDetails) {
  return {
    type: UPDATE_USAGE_SELECTED_ENTITLEMENT_DETAILS,
    payload: entitlementDetails
  };
};
export var UPDATE_USAGE_DETAILS_PAGINATION_DATA = 'UPDATE_USAGE_DETAILS_PAGINATION_DATA';
export var updateUsageDetailsPaginationData = function updateUsageDetailsPaginationData(paginationData) {
  return {
    type: UPDATE_USAGE_DETAILS_PAGINATION_DATA,
    payload: paginationData
  };
};
export var UPDATE_USAGE_SEARCH_ENTITLEMENTS_DATEPICKER = 'UPDATE_USAGE_SEARCH_ENTITLEMENTS_DATEPICKER';
export var updateUsageDetailsSearchEntitlementsDatePicker = function updateUsageDetailsSearchEntitlementsDatePicker(data) {
  return {
    type: UPDATE_USAGE_SEARCH_ENTITLEMENTS_DATEPICKER,
    payload: data
  };
};
export var UPDATE_USAGE_SEARCH_INCLUDE_EXPIRED = 'UPDATE_USAGE_SEARCH_INCLUDE_EXPIRED';
export var updateUsageDetailsSearchEntitlementsIncludeExpired = function updateUsageDetailsSearchEntitlementsIncludeExpired(data) {
  return {
    type: UPDATE_USAGE_SEARCH_INCLUDE_EXPIRED,
    payload: data
  };
};
export var CLEAR_USAGE_DETAILS_RECOVERABLE_UI_STATE = 'CLEAR_USAGE_DETAILS_RECOVERABLE_UI_STATE';
export var clearUsageDetailsRecoverableUIState = function clearUsageDetailsRecoverableUIState() {
  return {
    type: CLEAR_USAGE_DETAILS_RECOVERABLE_UI_STATE,
    payload: null
  };
};
export var RESET_SEARCH_ENTITLEMENTS_FILTERS = 'RESET_SEARCH_ENTITLEMENTS_FILTERS';
export var clearSearchEntitlementFiltersRecoverableUIState = function clearSearchEntitlementFiltersRecoverableUIState() {
  return {
    type: RESET_SEARCH_ENTITLEMENTS_FILTERS,
    payload: null
  };
};
export var SET_SELECTED_CALL_CATEGORIES = 'SET_SELECTED_CALL_CATEGORIES';
export var setSelectedCallCategories = function setSelectedCallCategories(callCategories) {
  return {
    type: SET_SELECTED_CALL_CATEGORIES,
    payload: callCategories
  };
};
export var SEARCH_USAGE_DETAILS_ENTITLEMENT_NAME = 'SEARCH_USAGE_DETAILS_ENTITLEMENT_NAME';
export var searchUsageDetailsEntitlementName = function searchUsageDetailsEntitlementName(entitlementName) {
  return {
    type: SEARCH_USAGE_DETAILS_ENTITLEMENT_NAME,
    payload: entitlementName
  };
};
export var RETRIEVE_USAGE_DETAILS_GROUPED_ENTITLEMENTS = {
  BEGIN: 'RETRIEVE_USAGE_DETAILS_GROUPED_ENTITLEMENTS_BEGIN',
  SUCCESS: 'RETRIEVE_USAGE_DETAILS_GROUPED_ENTITLEMENTS_SUCCESS',
  FAILURE: 'RETRIEVE_USAGE_DETAILS_GROUPED_ENTITLEMENTS_FAILURE'
};
export var retrieveUsageDetailsGroupedEntitlements = function retrieveUsageDetailsGroupedEntitlements(groupCode, serviceIdentifier) {
  return function (dispatch, getState) {
    var state = getState();
    var customerId = CurrentCustomerIdSelector(state);
    return thunkHelper(dispatch, Object.values(RETRIEVE_USAGE_DETAILS_GROUPED_ENTITLEMENTS), {
      method: 'post',
      url: 'SubscriberManagement/RetrieveEntitlementBalances',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
      data: {
        GroupCode: groupCode,
        ServiceIdentifier: serviceIdentifier || null,
        EntitlementPagination: {
          PageSize: 1000
        }
      }
    });
  };
};
export var RETRIEVE_USAGE_DETAILS_SERVICE_ENTITLEMENTS = {
  BEGIN: 'RETRIEVE_USAGE_DETAILS_SERVICE_ENTITLEMENTS_BEGIN',
  SUCCESS: 'RETRIEVE_USAGE_DETAILS_SERVICE_ENTITLEMENTS_SUCCESS',
  FAILURE: 'RETRIEVE_USAGE_DETAILS_SERVICE_ENTITLEMENTS_FAILURE'
};
var retrieveUsageDetailsServiceEntitlementsPromise = function retrieveUsageDetailsServiceEntitlementsPromise(dispatch, customerId, serviceIdentifier, includeAll, startDate, endDate) {
  return thunkHelper(dispatch, Object.values(RETRIEVE_USAGE_DETAILS_SERVICE_ENTITLEMENTS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveEntitlementBalances',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      EndDate: endDate,
      EntitlementPagination: {
        PageNumber: 1,
        PageSize: 25
      },
      GroupEntitlement: true,
      IncludeAll: includeAll,
      MaxNumberOfServiceEntitlements: 1000,
      MaxNumberOfSharedEntitlements: 0,
      ServiceIdentifier: {
        Value: serviceIdentifier
      },
      StartDate: startDate
    }
  });
};
export var retrieveUsageDetailsServiceEntitlements = function retrieveUsageDetailsServiceEntitlements(customerId, serviceIdentifier, includeAll, startDate, endDate) {
  return function (dispatch) {
    return retrieveUsageDetailsServiceEntitlementsPromise(dispatch, customerId, serviceIdentifier, includeAll, startDate, endDate);
  };
};
export var RETRIEVE_USAGE_DETAILS_SHARED_ENTITLEMENTS = {
  BEGIN: 'RETRIEVE_USAGE_DETAILS_SHARED_ENTITLEMENTS_BEGIN',
  SUCCESS: 'RETRIEVE_USAGE_DETAILS_SHARED_ENTITLEMENTS_SUCCESS',
  FAILURE: 'RETRIEVE_USAGE_DETAILS_SHARED_ENTITLEMENTS_FAILURE'
};
var retrieveUsageDetailsSharedEntitlementsPromise = function retrieveUsageDetailsSharedEntitlementsPromise(dispatch, customerId, serviceIdentifier) {
  return thunkHelper(dispatch, Object.values(RETRIEVE_USAGE_DETAILS_SHARED_ENTITLEMENTS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveEntitlementBalances',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      EntitlementPagination: {
        PageNumber: 1,
        PageSize: 25
      },
      GroupEntitlement: false,
      MaxNumberOfServiceEntitlements: 0,
      MaxNumberOfSharedEntitlements: 1000,
      ServiceIdentifier: {
        Value: serviceIdentifier
      }
    }
  });
};
export var retrieveUsageDetailsSharedEntitlements = function retrieveUsageDetailsSharedEntitlements(customerId, serviceIdentifier) {
  return function (dispatch) {
    return retrieveUsageDetailsSharedEntitlementsPromise(dispatch, customerId, serviceIdentifier);
  };
};